import Button from "../../../components/base-components/ButtonBase";
interface Props {
  title: string;
  level: string;
  description: string;
  onApply: (subject: string) => void;
}

const JoinTeamCard = ({ title, level, description, onApply }: Props) => (
  <div>
    <div className="mb-[1.2rem] flex items-center">
      <div className="p-[2rem] mr-[1.2rem] border rounded-[0.5rem] border-[rgba(0, 0, 0, 0.19)]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z"
            stroke="#FFCF32"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21"
            stroke="#FFCF32"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div>
        <h6 className="mb-[0.8rem]">{title}</h6>
        {/* <p>Level: {level}</p> */}
      </div>
    </div>
    <p className="md:max-w-[38.8rem]">{description}</p>
    <Button
      onClick={() => onApply(title)}
      modButtonClasses="md:max-w-[11rem] mt-[1.2rem]"
    >
      <p className="whitespace-nowrap">Apply now</p>
    </Button>
  </div>
);

export default JoinTeamCard;
